// initial state
const state = {
  tasks: []
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  setTasks(state, data) {
    state.tasks = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
